import script from "./LogUbica.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogUbica.vue?vue&type=script&lang=ts&setup=true"

import "./LogUbica.vue?vue&type=style&index=0&id=6b963c32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b963c32"]])

export default __exports__